var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.budgetList.length > 1
      ? _c(
          "div",
          { staticClass: "budgetList" },
          _vm._l(_vm.budgetList, function (item, index) {
            return _c(
              "div",
              {
                key: index,
                style:
                  item.id == _vm.chenckBudget.id
                    ? " box-shadow: 0px 1px 10px 2px rgba(0, 0, 0, 0.4);"
                    : "",
                on: {
                  click: function ($event) {
                    return _vm.changeBudget(item)
                  },
                },
              },
              [
                _vm._v(" 报价" + _vm._s(index + 1) + " "),
                item.isTemp !== 0
                  ? _c("span", { staticStyle: { "font-size": "0.12rem" } }, [
                      _vm._v("(已保存)"),
                    ])
                  : _c(
                      "span",
                      {
                        staticStyle: {
                          "font-size": "0.12rem",
                          color: "#E64A19",
                        },
                      },
                      [_vm._v("(编辑中)")]
                    ),
                _vm._v("  "),
                _c("span", [
                  _c("i", {
                    staticClass: "el-icon-document-copy",
                    staticStyle: { "margin-right": "0.05rem" },
                    on: {
                      click: function ($event) {
                        return _vm.copyBudget(item)
                      },
                    },
                  }),
                  item.isTemp !== 0
                    ? _c("i", {
                        staticClass: "el-icon-edit-outline",
                        staticStyle: { "margin-right": "0.05rem" },
                        on: {
                          click: function ($event) {
                            return _vm.editBudget(item)
                          },
                        },
                      })
                    : _vm._e(),
                  _c("i", {
                    staticClass: "el-icon-delete",
                    staticStyle: { "margin-right": "0.05rem" },
                    on: {
                      click: function ($event) {
                        return _vm.deleteBudgetMain(item)
                      },
                    },
                  }),
                  item.isTemp == 0
                    ? _c("span", {
                        staticStyle: {
                          "margin-right": "0.05rem",
                          display: "inline-block",
                          width: "0.16rem",
                        },
                      })
                    : _vm._e(),
                ]),
                _c("p", { staticStyle: { "font-size": "0.12rem" } }, [
                  _vm._v(_vm._s(_vm.dateFormatYMDHM(item.updateTime, "-"))),
                ]),
              ]
            )
          }),
          0
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }